import { moduleList, FINANCETODO } from '@/modules/transport/views/manageDesk/todoList';
import { getBmsInfo, getStatementInfo } from './manageDaskApi';
import { getSettleLists } from '@/modules/transport/bms/api/settleApi.js';
import { extsysInvoiceQuery } from '@/modules/transport/bms/api/invoiceManageApi.js';
import { getBillLists } from '@/modules/transport/bms/api/billApi.js';
import { querySupTask } from '@/modules/transport/bms/api/noTaxDebtProofApi.js';

import store from '@/store/index.js';

const config = moduleList.find((item) => item.code === FINANCETODO);
const supplier = store.getters.supplier;
const setNum = (code, num) => {
    const item = config.childList.find((item) => item.code === code);
    item.value = num;
};
/* 设置财务待办统计数 */
export const setFinancialToDoNum = () => {
    getBmsInfo().then((res) => {
        if (res) {
            const { feeTask } = res.data;
            setNum('checkFee', feeTask); // 费用核对
        }
    });
    getBillLists({
        billStatus: '30' // 新建和驳回
    }).then((res) => {
        if (res && +res.code === 0) {
            setNum('checkBill', res.data.totalCount); // 账单核对
        }
    });
    getSettleLists({
        statusArray: '10,47' // 新建和驳回
    }).then((res) => {
        if (res && +res.code === 0) {
            setNum('settlementApply', res.data.totalCount); // 结算申请
        }
    });
    extsysInvoiceQuery({
        makeInvoiceStatuses: '60,90'
    }).then((res) => {
        if (res && +res.code === 0) {
            setNum('invoiceManagement', res.data.totalCount); // 发票管理
        }
    });
    getStatementInfo({
        accountMode: 'A',
        dealingsBillStatuses: '20,30,50',
        isManage: 0,
        isSup: 1,
        isOrder: 1,
        supCode: supplier.supplierCode
    }).then(res => {
        setNum('dealingsCheckBill', res.data.totalCount); // 往来对账单
    });
    querySupTask({
        taskStatus: 'UN_SUBMIT',
        pageSize: 1000000
    }).then(res => {
        setNum('noTaxDebtProof', res.data.totalCount); // 无欠税证明
    });
};
